module.exports = __webpack_public_path__ + "media/images/flags/an-19a938b9e5b8b481a3bfcff0f886ffc6.svg";